/* eslint-disable */

import React, { useState, useRef, useEffect } from 'react';
import {
	Button,
	Grid,
	Typography,
	TextField,
	Popover,
} from '@material-ui/core';
import { 
	MAX_UPC_LIMIT, 
	COPY_PASTE_REGEX,
	MAIN_INSIGHTS_DASHBOARD
} from '../../constants/constant';
import useStyles from './styles';
import UPC from '../../assets/SVGs/UPC.svg';
import CloseIcon from '../../assets/SVGs/close.svg';
import closeicon from '../../assets/SVGs/closeIcon.svg';
import ErrorMarkIcon from '../../assets/SVGs/error-mark.svg';
import ErrorChipXIcon from '../../assets/SVGs/error-chip-x.svg';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LoadingDots from '../../assets/loading-dots.gif';
import { Box } from '@mui/material';
import {
	getUpcValidation,
	setSelectedUPC,
} from '../../redux/actions/salesActions';
import { UserPortalContext } from '../../context/appcontext';
import { useSelector, useDispatch } from 'react-redux';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import { isUPCSelected } from '../../redux/actions/appGuideActions';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';
import { colors } from '../../theme/color-palette';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const { DARK_PURPULE, PURPLE_AI, BLACK, LIGHT_GRAY_HEX } = colors;

export const paddUpcs = (upc) => {
	let paddedUpc = upc;
	let upcMaxLength = 13;
	if (upc && upc?.length < upcMaxLength) {
		let padding = '';
		for (let counter = 0; counter < upcMaxLength - upc?.length; counter++) {
			padding += '0';
		}
		paddedUpc = upc?.replace(/^/, padding);
	}
	return paddedUpc;
};

const CopyPasteUpcs = () => {
	const [selected, setSelected] = useState('upc');
	const [upc, setupcs] = useState([]);
	const [openItem, setOpenItem] = useState(false);
	const [value, setValue] = useState('');
	const [upcChips, setUpcChips] = useState([]);
	const [invalidUPCs, setInvalidUPCs] = useState({});
	const [validatingUpcs, setValidatingUpcs] = useState(false);
	const [validUpcs, setValidUpcs] = useState([]);
	const [maxUpcError, setMaxUpcError] = useState(false);
	const itemBtnRef = useRef(null);
	const classes = useStyles();

	const ref = useRef();
	const dispatch = useDispatch();

	const upcsValidationData = useSelector(
		(state) => state.salesReducer.validateUpc
	);

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const { selectedFilter } = selectedFilters;

	const { selectedUPC } = useSelector((state) => state.salesReducer);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	useEffect(() => {
		setValidUpcs([]);
		setOpenItem(false);
		setupcs([]);
		setUpcChips([]);
		dispatch(setSelectedUPC([]));
	}, [selectedView]);

	useEffect(() => {
		if (!selectedUPC?.length) {
			setValidUpcs([]);
			setUpcChips([]);
		}
	}, [selectedUPC]);

	useEffect(() => {
		if (upcsValidationData && Object.keys(upcsValidationData)) {
			const validChips = upcsValidationData?.upcs?.valid?.map(
				(object) => object.id
			);
			const invalidUpcs = upcsValidationData?.upcs?.invalid;

			if (invalidUpcs?.length) {
				const invalidChips = {};

				for (let i = 0; i < invalidUpcs?.length; i++) {
					let currentChip = paddUpcs(invalidUpcs[i]);
					invalidChips[currentChip] = true;
				}

				setInvalidUPCs(invalidChips);
				setValidatingUpcs(false);
				return;
			}

			setValidUpcs(validChips);
			dispatch(setSelectedUPC(validChips ? validChips : []));
			setInvalidUPCs({});

			const upcNumbers = validChips;
			closeDrawer();
			onClose({ upcs: upcNumbers });
		}

		setValidatingUpcs(false);
	}, [upcsValidationData]);

	const copyPasteRegex = COPY_PASTE_REGEX;

	useEffect(() => {
		if (Array.isArray(upc) && !upc.length) {
			setUpcChips([]);
		}

		if (Array.isArray(upc) && upc.length) {
			setUpcChips(upc);
		}
	}, [upc]);

	const closeDrawer = () => {
		setOpenItem(false);
		setInvalidUPCs({});
	};

	const maxUpcs = MAX_UPC_LIMIT;

	const onClose = (data) => {
		if (data?.upcs) {
			setupcs(data.upcs);
		}
	};

	useEffect(() => {
		setValidUpcs([]);
		setUpcChips([]);
		dispatch(setSelectedUPC([]));
	}, [selectedFilter]);

	useEffect(() => {
		if (Array.isArray(upcChips) && upcChips.length > maxUpcs) {
			setMaxUpcError(true);
			return;
		}
		setMaxUpcError(false);
	}, [upcChips, maxUpcs]);

	const parseAndSetUPCData = (data = '') => {
		const dups = {};
		const parsedData = data
			?.split(/\r\n|\r|\n|,/)
			?.map((d) => {
				let value = d.trim();
				return value?.replace(/['"]+/g, '');
			})
			?.filter((upc) => !!upc.length);
		const combinedChips = [...upcChips, ...parsedData];

		const newChips = combinedChips.filter((chip) => {
			if (!copyPasteRegex.test(chip) || chip.length > 13 || chip.length < 4) {
				return false;
			}
			if (dups[chip] === undefined) {
				dups[chip] = true;
				return true;
			} else {
				return false;
			}
		});
		setUpcChips([...newChips]);
		setTimeout(() => setValue(''));
	};

	const handlePaste = (event) => {
		const val = event.clipboardData.getData('text');
		parseAndSetUPCData(val);
	};
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			const val = event.target.value;
			if (val.length < 4) {
				return;
			}
			parseAndSetUPCData(val);
		}
	};

	const handleCancel = () => {
		setValidUpcs([]);
		setOpenItem(false);
		setupcs([]);
		setUpcChips([]);
		dispatch(setSelectedUPC([]));
	};

	const portalUserContext = React.useContext(UserPortalContext);

	const handleApply = () => {
		if (maxUpcError) return;
		setValidatingUpcs(true);

		const data = {
			reqBody: {
				channel: selectedFilter?.toUpperCase(),
				dim: selected === 'upc' ? 'UPC' : 'ITEM',
				validate: upcChips || [],
			},

			portalUserContext: portalUserContext,
		};
		dispatch(getUpcValidation(data));
		const request = {
			event: 'Search',
			event_description: selected === 'upc' ? 'UPC search' : 'Item Search',
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.UPC_SEARCH,
		});
	};

	const removeChip = (chip) => {
		const newChips = upcChips.filter((upcChip) => upcChip !== chip);
		chip = paddUpcs(chip);
		setUpcChips(newChips);
		setInvalidUPCs((prev) => {
			delete prev[chip];
			return prev;
		});

		// condition to refresh the dashboard if there are no chips when we remove
		if (validUpcs?.length && newChips?.length === 0) {
			setValidUpcs([]);
			dispatch(setSelectedUPC([]));
		}
	};

	const checkInvalidChip = (upc) => {
		return invalidUPCs[paddUpcs(upc)] !== undefined ? true : false;
	};
	const removeAllErrors = () => {
		setUpcChips((prev) => {
			return prev.filter((chip) => {
				chip = paddUpcs(chip);
				return invalidUPCs[chip] !== undefined ? false : true;
			});
		});
		setInvalidUPCs({});
	};

	const handleItemsOpen = () => {
		setOpenItem(true);
	};

	const handleCloseClick = () => {
		setValidUpcs([]);
		setUpcChips([]);
		dispatch(setSelectedUPC([]));
	};

	const isValidUPCs = validUpcs && validUpcs?.length > 0;

	const handleSelect = (e) => {
		const value = e.target.value;
		setSelected(value);
		dispatch(isUPCSelected(value === 'upc' ? true : false));
	};

	return (
		<>
			<Grid className={classes.itemContainer} ref={ref}>
				<Box className={classes.UpcButtonContainer}>
					<Button
						ref={itemBtnRef}
						startIcon={<img alt="UPC Copy Paste" src={UPC} />}
						className={`${classes.itemSelectBtn}
                          ${openItem ? classes.itemSelectBtnZIndex : ''} ${
							isValidUPCs ? classes.selected : ''
						}`}
						variant="outlined"
						endIcon={
							!isValidUPCs && (
								<ArrowDropDownIcon
									sx={{ color: DARK_PURPULE, fontSize: '24px' }}
								/>
							)
						}
						onClick={handleItemsOpen}>
						<span className={classes.itemState}>
							{isValidUPCs
								? `${selected === 'upc' ? 'UPC' : 'Item Number'}(${
										validUpcs?.length
								  })`
								: 'UPC/Item Number'}
						</span>
					</Button>
					{isValidUPCs && (
						<div
							style={{
								borderRadius: '0 4px 4px 0',
								borderColor: '#3C228A',
								borderStyle: 'solid',
								borderRightWidth: 1,
								borderTopWidth: 1,
								borderBottomWidth: 1,
								borderLeftWidth: 0,
								height: '100%',
								zIndex: 8,
								position: 'absolute',
								background: '#EBE8F3',
								borderLeft: 0,
								right: -44,
								width: 32,
								cursor: 'pointer',
								boxSizing: 'border-box',
								paddingLeft: 6,
								paddingRight: 6,
								verticalAlign: 'middle',
								boxShadow: '0 0 1px rgba(255, 255, 255, 0.5)',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
								alignItems: 'center',
								transform: 'scale(0.96)',
							}}
							onClick={handleCloseClick}>
							<img src={closeicon} alt="close-icon"></img>
						</div>
					)}
				</Box>

				{openItem && !upcChips.length && (
					<>
						<Popover
							open={openItem}
							anchorEl={itemBtnRef.current}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							className={classes.itemsPopover}
							onClose={closeDrawer}
							classes={{
								root: classes.popoverIndex,
							}}>
							<Grid
								container
								direction="column"
								className={`${classes.searchDropDown}`}>
								<FormControl
									sx={{
										marginLeft: 2,
									}}>
									<FormLabel
										sx={{
											fontFamily: 'Bogle-Regular !important',
											fontSize: '12px',
											fontStyle: 'normal',
											fontWeight: '400',
											color: BLACK,
											// marginLeft: '16px !important',

											'&.Mui-focused': {
												color: BLACK,
											},
										}}>
										<Box
											sx={{ marginLeft: '2px', }}
											>
										Select one:
										</Box>
									</FormLabel>
									<RadioGroup
										onChange={handleSelect}
										defaultValue={selected}
										row
										sx={{
											gap: '10px !important'
										}}
										aria-labelledby="demo-row-radio-buttons-group-label">
										<FormControlLabel
											value="upc"
											sx={{
												'& .MuiFormControlLabel-label': {
													fontSize: '14px',
													fontFamily: 'Bogle-Regular',
												},
											}}
											control={
												<Radio
													sx={{
														marginRight: '4px !important',
														color: LIGHT_GRAY_HEX,
														'&.Mui-checked': {
															color: PURPLE_AI,
														},
														'& .MuiSvgIcon-root': {
															fontSize: 20,
														},

														'& .MuiButtonBase-root': {
															'&:hover': {
																backgroundColor: 'transparent',
																background: 'none',
															},
														},
													}}
												/>
											}
											label="UPC"
										/>
										<FormControlLabel
											value="item"
											sx={{
												'& .MuiFormControlLabel-label': {
													fontSize: '14px',
													fontFamily: 'Bogle-Regular',
												},
											}}
											control={
												<Radio
													sx={{
														marginRight: '4px !important',
														color: LIGHT_GRAY_HEX,

														'&.Mui-checked': {
															color: PURPLE_AI,
														},
														'& .MuiSvgIcon-root': {
															fontSize: 20,
														},

														'& .MuiButtonBase-root': {
															'&:hover': {
																backgroundColor: 'transparent',
																background: 'none',
															},
														},
													}}
												/>
											}
											label="Item Number"
										/>
									</RadioGroup>
								</FormControl>
								<TextField
									inputProps={{
										className: classes.searchInput,
									}}
									value={value}
									onPaste={(event) => {
										handlePaste(event);
									}}
									onChange={(event) => {
										const value = event.target.value;
										if (value === '') {
											setValue(value);
										}
										if (value.length > 13 || !/^\d+$/.test(value)) {
											return;
										}
										setValue(value);
									}}
									onKeyDown={handleKeyDown}
									placeholder={'Type or paste values'}
									className={classes.searchContainer}
									variant="outlined"></TextField>
								<Grid container direction="column" justifyContent="flex-start">
									<Typography className={classes.searchSubText}></Typography>
								</Grid>
							</Grid>
						</Popover>
					</>
				)}
				{openItem && upcChips?.length > 0 && (
					<Popover
						open={openItem}
						anchorEl={itemBtnRef.current}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						className={classes.itemsPopover}
						onClose={closeDrawer}>
						<Grid
							container
							direction="column"
							className={`${classes.itemDropDown}`}>
							<Grid className={classes.chipsContainer}>
								{upcChips?.map((chip, idx) => (
									<Grid
										key={idx}
										className={`${classes.chips} ${
											checkInvalidChip(paddUpcs(chip)) ? classes.errorChip : ''
										}`}>
										<Grid>{chip}</Grid>
										<img
											onClick={() => removeChip(chip)}
											className={`${classes.closeChip}`}
											src={
												checkInvalidChip(paddUpcs(chip))
													? ErrorChipXIcon
													: CloseIcon
											}
											alt="Close drawer icon"
										/>
									</Grid>
								))}
							</Grid>
							<TextField
								onKeyDown={handleKeyDown}
								variant="outlined"
								inputProps={{
									className: classes.chipInput,
								}}
								className={classes.chipContainer}
								value={value}
								onChange={(event) => {
									const value = event.target.value;
									if (value === '') {
										setValue(value);
									}
									if (value.length > 13 || !/^\d+$/.test(value)) {
										return;
									}
									setValue(event.target.value);
								}}
								onPaste={(event) => handlePaste(event)}
								placeholder="Type or paste values"></TextField>
							<Grid container direction="column">
								{validatingUpcs ? (
									<Grid container>
										<Grid className={classes.itemValidation}>
											{`Validating ${
												selected === 'upc' ? 'UPC' : 'Item'
											} numbers`}
										</Grid>
										<img
											className={classes.loadingDots}
											alt="loading dots for upc validation"
											src={LoadingDots}
										/>
									</Grid>
								) : !!Object.keys(invalidUPCs).length ? (
									<Grid container justify="space-between" alignItems="center">
										<Grid className={classes.errormarkContainer}>
											<img
												alt="error mark on invalid UPC"
												src={ErrorMarkIcon}
											/>
											<Grid className={classes.itemValidationError}>
												{'Values error'}
											</Grid>
										</Grid>
										<Grid
											onClick={() => removeAllErrors()}
											tabIndex="0"
											role="button"
											aria-pressed="false"
											className={classes.removeAllErrors}>
											{'Remove all errors'}
										</Grid>
									</Grid>
								) : maxUpcError ? (
									<Grid container>
										<img
											alt="error mark on invalid number of UPCs"
											src={ErrorMarkIcon}
										/>
										<Grid className={classes.itemValidationError}>{`Maximum ${
											selected === 'upc' ? 'UPCs' : 'Items'
										} is ${maxUpcs} `}</Grid>
									</Grid>
								) : (
									<Grid className={classes.itemValidationSpacing}></Grid>
								)}

								<Box className={classes.btnContainer}>
									<Button onClick={handleCancel} className={classes.cancelBtn}>
										Cancel
									</Button>
									<Button
										disabled={
											maxUpcError ||
											validatingUpcs ||
											!!Object.keys(invalidUPCs).length
										}
										onClick={handleApply}
										variant="contained"
										color="primary"
										className={classes.applyBtn}>
										{'Apply'}
									</Button>
								</Box>
							</Grid>
						</Grid>
					</Popover>
				)}
			</Grid>
		</>
	);
};

export default CopyPasteUpcs;
